import * as React from "react";

import { get } from "lodash";
import { AnalyticsEvent } from "src/components/AnalyticsEvent";
import { analyticsDocumentTypes } from "src/components/AnalyticsEvent/AnalyticsEventContainer";
import { LocalizedString } from "src/components/Localization";
import { Loader, spinnerSize } from "src/components/LoadingSpinner/LoadingSpinner";
import { FlexContainer } from "src/design-system/Container";
import colors from "src/design-system/Tokens/colors";
import { Disclaimer } from "src/design-system/Tokens/typography";
import { analyticsEvents } from "src/events";
import { IconSize, PdfIcon } from "src/icons";
import { getDeliveryAttachmentDownloadUrl } from "src/util/commerce";
import { displayError } from "src/util/error";
import styled from "styled-components";

interface IDownloadProps {
  delivery: string;
  source: string;
}

const IconWrapper = styled(FlexContainer)`
  height: 50px;
  cursor: pointer;
`;

type DownloadState = "Idle" | "Downloading" | "Error";

export const DeliveryAttachmentDownload = (props: IDownloadProps) => {
  const [downloadState, setDownloadState] = React.useState<DownloadState>("Idle");

  const downloadAttachment = async () => {
    try {
      let downloadUrl;
      const { delivery, source } = props;
      downloadUrl = await getDeliveryAttachmentDownloadUrl(delivery, source);

      if (downloadUrl) {
        window.open(downloadUrl, "_blank");
        setDownloadState("Idle");
      } else {
        setDownloadState("Error");
      }
    } catch (e) {
      displayError(e);
      setDownloadState("Error");
    }
  };

  const handleClick = async () => {
    if (downloadState === "Idle") {
      setDownloadState("Downloading");
      await downloadAttachment();
    }
  };

  return (
    <AnalyticsEvent
      event={({ account, user }) =>
        analyticsEvents.dcpDownloadDocument({
          dcp_user_role: user.role,
          dcp_user_seniority: user.seniority,

          dcp_account_role: account.role,
          dcp_account_sector: account.sector,
          dcp_account_country: account.customerCountry,
          dcp_account_sales_region: account.salesRegion,
          dcp_account_market_segment: account.marketSegment,
          dcp_account_value_category: account.customerValueCategory,

          dcp_account_id: account.name,
          dcp_document_id: props.delivery,
          dcp_document_type: get(analyticsDocumentTypes, props.source, props.source),
        })
      }
    >
      <IconWrapper $centered onClick={handleClick}>
        {downloadState === "Idle" && <PdfIcon size={IconSize.Large} color={colors.primary.black} />}
        {downloadState === "Downloading" && <Loader dark size={spinnerSize.sm} />}
        {downloadState === "Error" && (
          <Disclaimer>
            <LocalizedString id="spareParts.noPDFinSAP" />
          </Disclaimer>
        )}
      </IconWrapper>
    </AnalyticsEvent>
  );
};
